import { Row, Col } from '@cleartrip/bento/lib';
import Image from "../../../../src/gatsby-theme-docz/components/Image";
import MediaRatios from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/media-ratios.png";
import MediaBaseline from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/media-baseline.jpg";
import MediaCard from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/media-card.png";
import MediaGrid from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/media-grid.png";
import * as React from 'react';
export default {
  Row,
  Col,
  Image,
  MediaRatios,
  MediaBaseline,
  MediaCard,
  MediaGrid,
  React
};